import { render, staticRenderFns } from "./Testpaper.vue?vue&type=template&id=1dd5ce29&scoped=true"
import script from "./Testpaper.vue?vue&type=script&lang=js"
export * from "./Testpaper.vue?vue&type=script&lang=js"
import style0 from "./Testpaper.vue?vue&type=style&index=0&id=1dd5ce29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd5ce29",
  null
  
)

export default component.exports